import { render, staticRenderFns } from "./BannerTasksMob.vue?vue&type=template&id=44d63278&scoped=true&"
import script from "./BannerTasksMob.vue?vue&type=script&lang=js&"
export * from "./BannerTasksMob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d63278",
  null
  
)

export default component.exports